import { getEndpointDescription } from './config/forms';
import { composeHttpHeaders } from './util/httpHeaders';

interface IFormData {
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  address?: string;
  address1?: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
  comments?: string;
  hasDealersLicence?: boolean;
  hasAcquiredLand?: boolean;
  timeline?: string;
}

export const submitContactForm = async (data: any) => {
  const formObj: IFormData = {
    email: data?.email,
    firstName: data?.firstName,
    lastName: data?.lastName,
    phone: data?.phone,
    address: data?.address,
    city: data?.city,
    state: data?.state,
    zip: data?.zip,
    comments: data?.comments,
  };

  const endpoint = getEndpointDescription('contactus');

  if (endpoint) {
    const submitResult = await fetch(endpoint.url, {
      method: 'POST',
      headers: {
        ...composeHttpHeaders().headers,
        'x-api-key': endpoint.apiKey,
      },
      body: JSON.stringify(formObj),
    }).catch((e) => console.error(e));
    return submitResult?.status;
  }
};

export const submitCrossmodForm = async (data: any) => {
  const formObj: IFormData = {
    firstName: data?.firstName,
    lastName: data?.lastName,
    email: data?.email,
    phone: data?.phone,
    city: data?.city,
    state: data?.state,
    zip: data?.zip,
    hasDealersLicence: data?.hasDealersLicence,
    hasAcquiredLand: data?.hasAcquiredLand,
    timeline: data?.timeline,
  };

  const endpoint = getEndpointDescription('crossmod');

  if (endpoint) {
    const submitResult = await fetch(endpoint.url, {
      method: 'POST',
      headers: {
        ...composeHttpHeaders().headers,
        'x-api-key': endpoint.apiKey,
      },
      body: JSON.stringify(formObj),
    }).catch((e) => console.error(e));
    return submitResult?.status;
  }
};

export const submitSubscribeForm = async (data: any) => {
  const formObj: IFormData = {
    firstName: data?.firstName,
    lastName: data?.lastName,
    email: data?.email,
    address1: data?.address1,
    address2: data?.address2,
    city: data?.city,
    state: data?.state,
    zip: data?.zip,
  };

  const endpoint = getEndpointDescription('openingdoors');

  if (endpoint) {
    const submitResult = await fetch(endpoint.url, {
      method: 'POST',
      headers: {
        ...composeHttpHeaders().headers,
        'x-api-key': endpoint.apiKey,
      },
      body: JSON.stringify(formObj),
    }).catch((e) => console.error(e));
    return submitResult?.status;
  }
};
